/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeType
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeType {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeType
     */
    ageTypeName?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeType
     */
    ageTypeValue?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeTypeFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeType {
    return JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeTypeFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ageTypeName': !exists(json, 'ageTypeName') ? undefined : json['ageTypeName'],
        'ageTypeValue': !exists(json, 'ageTypeValue') ? undefined : json['ageTypeValue'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeTypeToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ageTypeName': value.ageTypeName,
        'ageTypeValue': value.ageTypeValue,
    };
}

